import styled from 'styled-components';

export const IntegrationLabel = styled.span`
  display: ${({novelty}) => novelty && (novelty === 'normal') ? 'none' : 'inline-block'};
  border-radius: 4px;
  padding: 2px 8px;
  min-width: 44px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  text-transform: capitalize;
  color: ${({novelty}) => novelty === 'new' ? '#ffffff' : '#68D391'};
  background-color: ${({novelty}) => novelty === 'new' ? '#68D391' : '#E1F6E9'};
  box-sizing: border-box;
  user-select: none;
`;
